// Kompakte Darstellung eines Runs für das URL-Fragment im QR-Code (base64url-JSON).
export function encodeRun({ token, industry, employees, seed, guess, nickname, completedAt, actions }) {
  const json = JSON.stringify({
    v: 1, k: token, i: industry, e: employees, s: seed, g: guess, n: nickname || "", t: completedAt,
    a: actions.map((a) => [a.id, a.round])
  })
  const bytes = new TextEncoder().encode(json)
  let binary = ""
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "")
}

export function decodeRun(encoded) {
  const base64 = encoded.replaceAll("-", "+").replaceAll("_", "/")
  const binary = atob(base64 + "=".repeat((4 - (base64.length % 4)) % 4))
  const data = JSON.parse(new TextDecoder().decode(Uint8Array.from(binary, (c) => c.charCodeAt(0))))
  if (data.v !== 1) throw new Error("Unbekanntes Format")
  return {
    token: data.k, industry: data.i, employees: data.e, seed: data.s, guess: data.g, nickname: data.n,
    completedAt: data.t, actions: data.a.map(([id, round]) => ({ id, round }))
  }
}
